<template>
    <div class="tm-distribution tm-info" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
         infinite-scroll-distance="10">
        <ul>
            <li v-for="(infoItem, infoIndex) in dataList" :key="infoIndex">

                <div class="over-main" v-html="infoItem.protocolContent"></div>
            </li>
        </ul>
        <div class="loadingBox" v-show="isLoding">
            <div class="loader"></div>
        </div>
        <div class="exclusive-enjoy">
            <button class="bigBtn default-button" @click="agree">确定</button>
        </div>
    </div>
</template>
<script>

    import infiniteScroll from "vue-infinite-scroll";
    import {formatNumber, queryUrl} from "@/utils/index";
    import {callHandler} from "@/utils/bridge";
    import sensors from "sa-sdk-javascript";

    const {type} = queryUrl(location.href);
    export default {
        data() {
            return {
                productId: "",
                dataList: [],
                busy: false,
                protocolId: 16,
                isLoding: false,
                protocolTypeArr: []
            };
        },
        directives: {
            infiniteScroll
        },
        created() {
            let params = this.$route.query;
            const {token, productId, type} = params;
            this.productId = productId;
            this.token = decodeURIComponent(token || "");
        },
        mounted() {
            sensors.track("TMLoanAgreement");
        },
        methods: {
            loadMore: (function () {
                let pageNo = 0,
                    protocolTypeArr;
                switch (type) {
                    case 'jxl':
                        protocolTypeArr = [ 20, 21, 19];
                        break;
                    case 'huacai':
                        protocolTypeArr = [ 22 ];
                        break;
                    default:
                        protocolTypeArr = [15, 16, 8, 18, 9, 1, 3];
                        break;
                }
                let protocolType = protocolTypeArr[pageNo];
                return function () {
                    this.isLoding = true;
                    let url = `/h5/protocol/productPrototol?token=${this.token}`;
                    if(type === 'huacai'){
                        url += `&protocolType=22`;
                    }else{
                        url += `&protocolType=${protocolType}&productId=${this.productId}`;
                    }
                    this.$request({
                        method: "get",
                        url: url
                    })
                        .then(res => {
                            this.isLoding = false;
                            const {data} = res;
                            if (!this.dataList.some(item => item.protocolName === data.protocolName)) {
                                this.dataList.push(res.data);
                                pageNo++;
                            }

                            protocolType = protocolTypeArr[pageNo];
                            if (!protocolType) {
                                this.busy = true;
                            }
                        })
                        .catch(err => {
                            this.$toast(err);
                        });
                };
            })(),
            format(num) {
                return formatNumber(num);
            },

            agree() {
                if(type === 'huacai'){
                    this.$router.push({name:'huacaiLoading',query: {token: this.token}});
                }else{
                    callHandler("xhP2PAgreeAgreement");
                }
            }
        }
    };
</script>
<style lang="less">
    .tm-distribution {
        width: 100%;
        background: #fff;
        border-radius: 20px;
        padding: 20px 16px;
        margin-bottom: 80px;
        box-sizing: border-box;

        ul {
            width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            overflow: hidden;

            li {
                .over-title {
                    text-align: center;
                    display: block;
                    width: 100%;
                    font-size: 15px;
                    color: #333333;
                    margin-bottom: 18px;
                    line-height: 20px;
                }
            }
        }

        /*第三种动画加载开始*/

        .loader {
            display: block;
            width: 40px;
            height: 40px;
            -webkit-animation: loading-3 1s ease 0.48s infinite;
            animation: loading-3 1s ease 0.48s infinite;
            margin: 0 auto;
        }

        @-webkit-keyframes loading-3 {
            0% {
                background: url(../../../assets/images/normal/loading_1.png) no-repeat;
                background-size: 100% 100%;
            }

            20% {
                background: url(../../../assets/images/normal/loading_2.png) no-repeat;
                background-size: 100% 100%;
            }

            40% {
                background: url(../../../assets/images/normal/loading_3.png) no-repeat;
                background-size: 100% 100%;
            }

            60% {
                background: url(../../../assets/images/normal/loading_4.png) no-repeat;
                background-size: 100% 100%;
            }

            80% {
                background: url(../../../assets/images/normal/loading_5.png) no-repeat;
                background-size: 100% 100%;
            }

            100% {
                background: url(../../../assets/images/normal/loading_6.png) no-repeat;
                background-size: 100% 100%;
            }
        }

        table {
            margin-right: 0 !important;
            margin-left: 0 !important;
            width: 100% !important;
        }
    }
</style>
